import { RootState } from '../store/types';
import { useAppSelector } from './state';

export const useUserDetails = () => {
  const user = useAppSelector((state: RootState) => state.auth.user);
  return { user };
};

export default useUserDetails;
